import React from 'react';
import { GiFarmer } from 'react-icons/gi';
import { lazyPage } from '../lazyPage';

const FarmerListPage = lazyPage(() => import(/* webpackChunkName: "m-people" */ './pages/FarmerListPage'));

/** Farmer directory — People module. Identical to the previous legacy declaration. */
const farmerManifest = {
    id: 'farmers',
    featureName: '360farmer_mgmt',
    permission: 'view',
    routes: [{ path: '/farmers', element: <FarmerListPage /> }],
    sidebarItems: [{ text: 'Farmer', icon: <GiFarmer />, link: '/farmers' }],
};

export default farmerManifest;
